module.exports = __webpack_public_path__ + "img/facebook-logo.4878a3ae.png";